import {AjaxHandler} from "../../stem-core/base/Ajax";
import {type DataType, XHRPromise} from "../../stem-core/base/Fetch";

export const RequestCache = {
    ajaxHandler: new AjaxHandler(null),
    cache: new Map<string, XHRPromise>(),

    async loadJSON(path: string): Promise<any> {
        return this.load(path, "json");
    },

    // A promise resolves to the same value if re-evaluated
    async load(path: string, dataType: DataType): Promise<any> {
        let resource = this.cache.get(path);
        if (!resource) {
            resource = this.ajaxHandler.fetch(path, {dataType, data: {}, method: "GET"});
            if (resource) {
                this.cache.set(path, resource);
            }
        }

        return resource;
    }
}
